import Hero from '../components/Hero';
import '../styles/Pages.css';
function DevOps({ setCurrentPage }) {
    return (
      <>
      <Hero title="DevOps Services" image="/images/devops.jpg" compact />
      <div className="page service-page">
  <div className="service-content">
          <div>
            <img src="/images/devops.jpg" alt="DevOps" />
          </div>
          <div className="service-text">
            <h3>DevOps</h3>
            <p>
              DevOps is the blend of social ways of thinking, practices, and instruments that
              builds an association’s capacity to convey applications and administrations at high
              speed: developing and further developing items at a quicker pace than associations
              utilizing customary programming improvement and foundation the board processes.
            </p>
            <p>
              DevOps combines cultural philosophies, practices, and tools to enhance an
              organization’s ability to deliver applications and services at high speed. It enables
              faster development and improvement of products compared to traditional software
              development and infrastructure management approaches.
            </p>
            <button className="cta-button" onClick={() => setCurrentPage('Contact')}>
              Get Started Today
            </button>
          </div>
        </div>
  
        <section className="about-section">
          
        </section>
      </div>
      </>
    );
  }
  
  export default DevOps;